import { Controller } from "@hotwired/stimulus"

// Simple expand/collapse for truncated text
export default class extends Controller {
  static targets = ["text", "toggle"]
  static classes = ["clamp"]
  static values = { expanded: { type: Boolean, default: false } }

  connect() {
    // Store original classes for restoration
    this.originalClasses = this.hasClampClass
      ? this.clampClasses
      : ["line-clamp-1", "sm:line-clamp-2"]

    this.updateDisplay()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation() // Prevent card selection

    this.expandedValue = !this.expandedValue
    this.updateDisplay()
  }

  updateDisplay() {
    if (!this.hasTextTarget || !this.hasToggleTarget) return

    if (this.expandedValue) {
      // Remove all line-clamp classes
      this.textTarget.classList.remove("line-clamp-1", "line-clamp-2", "sm:line-clamp-2")
      this.toggleTarget.textContent = "Less −"
    } else {
      // Restore clamp classes
      this.originalClasses.forEach(cls => {
        this.textTarget.classList.add(cls)
      })
      this.toggleTarget.textContent = "More +"
    }
  }
}
